import { gql } from '@apollo/client';

export const BUILD_CATEGORIE_RESTRICTION_TREE = gql`
    query BuildCategorieRestrictionTree {
        buildCategorieRestrictionTree {
            id
            name
            count
            children {
                id
                name
                count
                children {
                    id
                    name
                    count
                }
            }
        }
    }
`;
